import { Text } from 'react-native-paper';

import { useTranslation } from '@/i18n';

export const StartRecordingNote = () => {
  const { t } = useTranslation();
  const prefix = t('recording.startConfirmation.notePrefix');
  const body = t('recording.startConfirmation.noteBody');
  const suffix = t('recording.startConfirmation.noteSuffix');

  if (prefix === '' && body === '' && suffix === '') {
    return null;
  }

  return (
    <Text variant="bodyMedium">
      <Text style={{ fontWeight: 'bold' }}>{prefix}</Text>
      {body}
      <Text style={{ fontWeight: 'bold' }}>{suffix}</Text>
    </Text>
  );
};
